module.exports = __webpack_public_path__ + "img/fullstackProjectWhite.2f0299e3.svg";